import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=9bca5eaa&scoped=true&"
import script from "./checkDetail.vue?vue&type=script&lang=js&"
export * from "./checkDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=9bca5eaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bca5eaa",
  null
  
)

export default component.exports